module.exports = __webpack_public_path__ + "static/media/Hitmonchan_gaussian2.c8ab188a.png";